export default __webpack_public_path__ + "static/media/img3.386bad6a.jpg";